import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ContentsBase } from '@routes/tickets/ticket-edit/contents/contents-base';
import { finalize, takeWhile } from 'rxjs/operators';
import { TicketCreate } from '@shared/models/ticket-create';
import Utils from '@shared/utils/utils';
import { Product } from '@shared/models/product';
import { Sc4uInfo } from '@shared/models/sc4u-info';
import { Basic } from '@shared/models/basic';
import { Symptom } from '@shared/models/symptom';
import { Constants } from '@shared/constants/constants';
import { Company } from '@shared/enums/company';
import * as _ from 'lodash-es';

@Component({
  selector: 'app-symptom',
  templateUrl: './symptoms.component.html',
  styleUrls: ['./symptoms.component.scss']
})
export class SymptomsComponent extends ContentsBase implements OnInit, OnDestroy, AfterViewInit {

  basic: Basic = {};
  product: Product = {};
  sc4uInfo: Sc4uInfo = {};
  symptoms: Symptom[] = [];
  text: any;

  symptomList: any = {};
  selectedSymptom: any;

  dialogCommunications: any[] = [];

  isDialog = false;

  companies = Company;

  ngOnInit(): void {
    this.init('symptoms');

    this.symptomList = {};
    this.selectedSymptom = null;
    this.text = null;
    this.isDialog = false;
    this.dialogCommunications = [];

    if (this.ticketService) {
      this.ticketService.data$
        .pipe(takeWhile(() => this.alive))
        .subscribe((ticket: TicketCreate) => {

          // console.log('# symptoms >>>>>>>>>>> ', ticket);
          if (Utils.isEmpty(ticket)) {
            return;
          }

          ['basic', 'product', 'sc4uInfo', 'symptoms'].forEach(x => {
            if (x === 'product') {
              if (this.product?.serialNo !== ticket[x]?.serialNo) {
                this.symptomList = {};
                this.selectedSymptom = null;
                this.text = null;
                this.isDialog = false;
                this.dialogCommunications = [];
              }
            }
            this[x] = ticket[x];
          });

          const { serialNo, modelCode, productType } = this.product || {};

          if (!modelCode) {
            return;
          }

          if ([Constants.serviceCode.STOCK_REPAIR, Constants.serviceCode.DEMO_SERVICE].includes(this.basic?.serviceType) && !this.symptoms) {
            this.symptomList = {};
            this.selectedSymptom = null;
            this.isDialog = false;
          }

          if (!_.isEqual(this.selectedSymptom?.symptomsDescription, this.symptoms)) {
            // @ts-ignore
            this.selectedSymptom?.symptomsDescription = this.symptoms;
            this.symptomList = {};
          }

          if (this.isDetail && this.symptoms && !this.selectedSymptom?.name) {
            this.selectedSymptom = {
              symptomsDescription: this.symptoms
            };
            // return;
          }
          this.load(serialNo, productType);
        });
    }
  }

  ngOnDestroy() {
    this.alive = false;
  }

  ngAfterViewInit() {
    // this.ticketService.scrollToBottom();
  }

  load(serialNo, productType) {
    const { serviceType } = this.basic;
    const { warrantyTerm } = this.product;
    const storeType = [Constants.serviceCode.STOCK_REPAIR, Constants.serviceCode.DEMO_SERVICE].includes(serviceType);

    if (Utils.isEmpty(this.symptomList)) {
      this.spinnerService.start('simpleSymptoms');
      if (!storeType && this.sc4uInfo) {
        const { sc4uObjectId, sc4uTarget, checkHrm } = this.sc4uInfo;
        if (serviceType === Constants.serviceCode.IN_HOME && !(warrantyTerm === 'OW' && !sc4uTarget) && checkHrm) {
          this.getHrmErrors(serialNo, sc4uObjectId, productType);
          return;
        }
      }
      this.getSimpleSymptoms(productType);
    }
  }

  getHrmErrors(serialNo, sc4uObjectId, productType) {
    this.apiService.sc4u.getHrmErrors(serialNo, sc4uObjectId)
      .subscribe(res => {
        const { errors } = res;
        if (errors.length) {
          const data = errors.map(m => {
            m.name = m.hrmSymptom;
            m.symptoms = [m.gcicSymptom1, m.gcicSymptom3, m.gcicSymptom3];
            return m;
          });

          this.symptomList = {
            data,
            type: 'hrm'
          };

          this.symptomList.data.push({
            name: 'Not Found',
            symptoms: null,
          });

          if (this.isDetail && this.symptoms && this.symptomList.data.length) {
            const checkSymptom = this.getDetailSymptoms() || {};
            this.selectedSymptom.symptoms = checkSymptom?.symptoms
            this.selectedSymptom.type = 'hrm';
            this.selectedSymptom.name = checkSymptom?.name;
          }

          this.spinnerService.stop('simpleSymptoms');
          this.ticketService.scrollToBottom();
          return;
        }
        this.getSimpleSymptoms(productType);
      }, err => Utils.showError(err));
  }

  hrmNotFound() {
    const { productType } = this.product;

    this.spinnerService.start('simpleSymptoms');
    this.getSimpleSymptoms(productType);
  }

  getSimpleSymptoms(productType) {
    this.apiService.product.getSimpleSymptoms(productType)
      .pipe(finalize(() => this.spinnerService.stop('simpleSymptoms')))
      .subscribe(res => {
        this.symptomList = {
          data: res,
          type: 'dsr'
        };

        if (this.isDetail && this.symptoms && this.symptomList.data.length) {
          const checkSymptom = this.getDetailSymptoms() || {};
          this.selectedSymptom.symptoms = checkSymptom?.symptoms
          this.selectedSymptom.type = 'dsr';
          this.selectedSymptom.name = checkSymptom?.name;
        }
        // this.ticketService.isScroll$.next(true);
      }, err => Utils.showError(err));
  }

  getDetailSymptoms() {
    const symptomsCodes = this.symptoms.reduce((prev, item): any => {
      if (!!item.code.trim()) {
        prev.push(item.code);
      }
      return prev;
    }, []);
    const equals = (a, b) =>
      a.length === b.length &&
      a.every((v, i) => v === b[i]);
    const [checkSymptom] = this.symptomList.data.filter(f => equals(f.symptoms, symptomsCodes));
    return checkSymptom;
  }

  async selectSymptom(item: any, type) {
    if (!item.symptoms) {
      this.hrmNotFound();
      return;
    }

    item.type = type;

    this.selectedSymptom = await this.getSymptomsDescription(item);
    const { sc4uTarget } = this.sc4uInfo || {};
    const { serviceType } = this.basic;
    if (['detail', 'hrm'].includes(type) || (!sc4uTarget && type === 'dsr') || [Constants.serviceCode.PICKUP_SERVICE, Constants.serviceCode.DEMO_SERVICE].includes(serviceType)) {
      this.ticketService.patch({ symptoms: item.symptomsDescription }, 'symptoms :: selectSymptom');
    }

    this.ticketService.scrollToBottom();
  }

  async getSymptomsDescription(item) {
    const { productType } = this.product;
    this.spinnerService.start();
    const result = await this.apiService.product.getSymptomsDescription(productType).toPromise();
    if (result) {
      this.spinnerService.stop();
    }
    let symptomDescriptions = [];
    const firstSymptom = result.symptoms.find(s => s.code === item.symptoms[0]);
    symptomDescriptions.push({
      code: item.symptoms[0],
      description: firstSymptom?.name || ''
    });
    const secondSymptom = firstSymptom?.symptoms.find(s => s.code === item.symptoms[1]);
    symptomDescriptions.push({
      code: item.symptoms[1],
      description: secondSymptom?.name
    });
    const thirdSymptom = secondSymptom?.symptoms.find(s => s.code === item.symptoms[2]);
    symptomDescriptions.push({
      code: item.symptoms[2],
      description: thirdSymptom?.name
    });

    item.symptomsDescription = symptomDescriptions;
    return item;
  }

  viewResult(): any {
    const item = this.selectedSymptom;

    if (this.isDetail) {
      return true;
    }

    const { sc4uTarget, dialogStatus } = this.sc4uInfo || {};

    if (dialogStatus === 'END') {
      return true;
    }

    switch (item.type) {
      case 'hrm':
        return true;
      case 'dsr':
        return !sc4uTarget;
    }
  }

  cancelSymptom() {
    this.selectedSymptom = null;
    this.symptomList = {};
    this.dialogCommunications = [];
    this.isDialog = false;

    const sc4uInfo = this.sc4uInfo || {};
    delete sc4uInfo.rootId;
    delete sc4uInfo.dialogId;
    delete sc4uInfo.dialogStatus;
    delete sc4uInfo.dialogSymptom;
    delete sc4uInfo.dialogCommunications;
    if (!this.symptoms) {
      const { serialNo, productType } = this.product;
      this.load(serialNo, productType);
      // this.ticketService.patch({ symptoms: null, serviceCenter: null }, 'cancelSymptom :: null');
    } else {
      this.ticketService.patch({ symptoms: null, serviceCenter: null }, 'cancelSymptom :: null');
    }
  }

  startDialog() {
    const { sc4uObjectId } = this.sc4uInfo;
    const { symptoms } = this.selectedSymptom;

    this.spinnerService.start();
    this.apiService.sc4u.dialogEngineStart(sc4uObjectId, symptoms, this.text)
      .subscribe(res => {
        const { success, data } = res;
        const { rootId, dialogId, dialogSymptom } = data;
        this.isDialog = success;

        const sc4uInfo = {
          ...this.sc4uInfo,
          rootId,
          dialogId,
          dialogSymptom,
        };

        this.ticketService.patch({ sc4uInfo }, 'symptoms :: startDialog');
        this.dialog(sc4uObjectId, rootId, dialogId, dialogSymptom);
      }, error => {
        this.isDialog = false;
        this.spinnerService.stop();
        Utils.showError(error);
      });
  }

  dialog(sc4uObjectId, rootId, dialogId, dialogSymptom, index = 0, partIndices = [], parts = []) {
    this.apiService.sc4u.dialogEngine(sc4uObjectId, rootId, dialogId, dialogSymptom, index, partIndices, parts)
      .pipe(finalize(() => this.spinnerService.stop()))
      .subscribe(res => {
        const { status, question, data, parts } = res;
        if (data.length) {
          this.dialogCommunications.push({
            status, question, data
          });
        }

        let value: any = {
          sc4uInfo: {
            ...this.sc4uInfo,
            dialogCommunications: this.dialogCommunications,
            dialogParts: parts
          }
        };

        if (status === 'END') {
          value.sc4uInfo = {
            ...value.sc4uInfo,
            dialogStatus: status,
          };
          value.symptoms = this.selectedSymptom.symptomsDescription;
        }

        this.ticketService.patch(value, 'symptoms :: dialog');
      }, error => Utils.showError(error));
  }

  selectDialog(item: any, idx) {
    const { sc4uObjectId, rootId, dialogId, dialogSymptom } = this.sc4uInfo;
    const { index, partIndices, parts } = item;

    this.sc4uInfo.dialogCommunications = this.dialogCommunications[idx].answer = item;
    this.ticketService.patch({ sc4uInfo: this.sc4uInfo }, 'symptoms :: selectDialog');

    this.spinnerService.start();
    this.dialog(sc4uObjectId, rootId, dialogId, dialogSymptom, index, partIndices, parts);
  }

  cancelDialog(i) {
    delete this.sc4uInfo.dialogStatus;
    delete this.dialogCommunications[i].answer;
    this.dialogCommunications.splice(i + 1);

    this.ticketService.patch({
      sc4uInfo: this.sc4uInfo,
      symptoms: null,
      pricing: null,
      serviceCenters: null,
      serviceCenter: null
    }, 'symptoms :: cancelDialog');
  }
}
